<script setup lang="ts">
import { computed } from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {Address} from "@/types/Wiser/address.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for Address.
 *
 * Narrowing `entity` to `Address` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<Address>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed(() => props.entity?.id ?? 0)
const gotoDetail = function() {
  router.push({name: 'wiser-address', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item address-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title address-item__title"
    >
      <span>{{ entity.id }}</span>
      <span class="wiser-item__badge relation-item__badge">{{ entity.adrestype }}</span>
    </component>
    <span>{{ entity.adres }} {{ entity.huisnummer }}, {{ entity.postcode }} {{ entity.plaats }}</span>
  </article>
</template>
